import React from 'react'
import styles from './create-assessment.styles'
import injectSheet from 'react-jss'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import * as Yup from 'yup'
import { Formik } from 'formik'
import PaperclipIcon from 'react-icons/lib/fa/paperclip'
import FormSelect from 'pobble-components/dist/form-elements/form-select'

const CreateAssessment = ({
  classes,
  opened,
  name,
  count,
  requestClose,
  onSubmit
}) => (
  <Modal isOpen={opened}>
    <ModalHeader>New moderation file for {name}</ModalHeader>
    <Formik
      validationSchema={Yup.object().shape({
        title: Yup.string().required(
          'Please provide a title to your moderation file'
        ),
        context: Yup.string().required(
          'Please provide a context to your moderation file'
        )
      })}
      onSubmit={onSubmit}
      initialValues={{
        title: '',
        context: '',
        moderation_type: '',
        judgement: ''
      }}>
      {props => {
        const {
          handleChange,
          handleSubmit,
          handleBlur,
          errors,
          isValid,
          touched,
          values
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy className={classes.modalContent}>
              <div className={classes.part}>
                <FormLabel htmlFor={'title'} className={classes.label}>
                  Title
                </FormLabel>
                <FormInput
                  type="text"
                  validationError={touched.title ? errors.title : null}
                  name="title"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className={classes.part}>
                <FormLabel htmlFor={'context'} className={classes.label}>
                  Context
                </FormLabel>
                <FormTextArea
                  validationError={touched.context ? errors.context : null}
                  placeholder={
                    'E.g. context for this moderation file, or a specific question for moderators.'
                  }
                  name="context"
                  value={values.context}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <div>
                  <PaperclipIcon /> {count} piece
                  {count > 1 ? 's' : ''}
                </div>
                <div className={classes.optionals}>
                  <div className={classes.part}>
                    <FormLabel
                      htmlFor={'moderation_type'}
                      className={classes.label}>
                      Type{' '}
                      <small className={classes.optional}>(optional)</small>
                    </FormLabel>
                    <FormSelect
                      value={values.moderation_type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="moderation_type">
                      <option value={''} default>
                        Not applicable
                      </option>
                      <option value={'in_school_moderation'}>
                        In school moderation
                      </option>
                      <option value={'cross_school_moderation'}>
                        Cross school moderation
                      </option>
                      <option value={'statutory_moderation'}>
                        Statutory moderation
                      </option>
                      <option value={'external_non_statutory_moderation'}>
                        External non statutory moderation
                      </option>
                    </FormSelect>
                  </div>
                  <div className={classes.part}>
                    <FormLabel htmlFor={'judgement'} className={classes.label}>
                      Judgement
                      <small className={classes.optional}>(optional)</small>
                    </FormLabel>
                    <FormSelect
                      value={values.judgement}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="judgement">
                      <option value={''} default>
                        Not applicable
                      </option>
                      <option value={'working_towards_the_expected_standard'}>
                        Working towards the expected standard (WTS)
                      </option>
                      <option value={'working_at_the_expected_standard'}>
                        Working at the expected standard (EXS)
                      </option>
                      <option
                        value={'greater_depth_within_the_expected_standard'}>
                        Greater depth within the expected standard (GDS)
                      </option>
                      <option value={'eyfs_emerging'}>EYFS Emerging</option>
                      <option value={'eyfs_expected'}>EYFS Expected</option>
                    </FormSelect>
                  </div>
                </div>
              </div>
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button
                simple
                tall
                type="button"
                className={classes.cancel}
                action={requestClose}>
                Cancel
              </Button>
              <Button disabled={!isValid} tall type="submit">
                Create moderation file
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(CreateAssessment)
